export const menu = {
    label: 'Contas',
    icon: 'pi pi-fw pi-dollar',
    to: '/pagamentos/contas',
    rules: ['PAG-CONTAS-00'],
};
